import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=1649291e&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=1649291e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1649291e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3833976396/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1649291e')) {
      api.createRecord('1649291e', component.options)
    } else {
      api.reload('1649291e', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=1649291e&scoped=true", function () {
      api.rerender('1649291e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Notifications.vue"
export default component.exports